module.exports = __webpack_public_path__ + "static/client-logo-51d063d5d4df84ba3c204eb948195ccc.png";